import React from 'react';
import PropTypes from 'prop-types';
import { TextareaAutosize, styled } from '@mui/material';

export const StyledInputTextArea = styled(TextareaAutosize)(({ theme }) => ({
  '&': {
    padding: '12px',
    background: '#FFFFFF',
    border: '0.5px solid',
    borderColor: theme.palette.action.disabled,
    borderRadius: '12px',
    fontSize: '1.125rem',
    fontFamily: theme.typography.fontFamily,
    outline: 'none',
    scrolbarWidth: 'none',
    overflow: 'auto !important',
    overflowX: 'scroll !important',
    width: '100%',
    '&::-webkit-scrollbar': { width: 0, height: 0 }
  },

  '&:hover': {
    borderColor: theme.palette.text.secondary
  },

  '&:focus': {
    borderColor: theme.palette.primary.main
  },

  '&[error]': {
    borderColor: theme.palette.error.main,
    background: theme.palette.error.light
  },

  '&::placeholder': {
    color: theme.palette.grey[1000]
  },

  '&[disabled]': {
    background: theme.palette.action.disabledBackground,
    '-webkit-text-fill-color': theme.palette.grey[1000],
    '&:hover': { borderColor: theme.palette.action.disabled }
  }
}));

export const CustomInputTextArea = ({ value, ...props }) => (
  <StyledInputTextArea value={value || ''} {...props} />
);

CustomInputTextArea.propTypes = {
  value: PropTypes.string
};

CustomInputTextArea.defaultProps = {
  value: undefined
};
